
import { v4 as uuidv4 } from 'uuid';
import { collection, query, where, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "@/services/firebaseService";

const INVITATIONS_COLLECTION = "userInvitations";

/**
 * Generate a unique token for user invitations
 */
export const generateUniqueToken = async (): Promise<string> => {
  // Use UUID v4 to generate a random token (36 characters)
  const token = uuidv4().replace(/-/g, ''); // Remove dashes to make it 32 characters
  
  // Check if a document with this token as ID already exists to ensure uniqueness
  const docRef = doc(db, INVITATIONS_COLLECTION, token);
  const docSnap = await getDoc(docRef);
  
  // If the document already exists (extremely unlikely with UUID v4), generate a new one
  if (docSnap.exists()) {
    return generateUniqueToken();
  }
  
  return token;
};

/**
 * Validate token format
 */
export const validateTokenFormat = (token: string): boolean => {
  // Ensure token is the expected length (32 chars)
  if (!token || token.length !== 32) {
    return false;
  }
  
  // Ensure token only contains hexadecimal characters
  const hexRegex = /^[0-9a-f]+$/i;
  return hexRegex.test(token);
};
